<ion-text color="dark">
  <p
    [innerHTML]="node?.text"
    [ngClass]="['ion-text-' + node?.alignment]"
    [style.maxHeight]="maxHeight"
    hrefToRouterLink
  ></p>
  <a *ngIf="!desktop && readMore" (click)="toggleReadMore()"
    >Read {{ readMoreVisible ? "less" : "more" }}</a
  >
</ion-text>
